import { useFormContext } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/shared/ui/form";
import { Input } from "@/shared/ui/input";
import { Button } from "@/shared/ui/button";
import { PasswordResetFormValues } from "@/shared/lib/validation/user-schemas";
import { useTranslations } from "next-intl";

interface PasswordStepProps {
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
}

export function PasswordStep({ confirmPassword, setConfirmPassword }: PasswordStepProps) {
  const t = useTranslations();
  const form = useFormContext<PasswordResetFormValues>();

  const newPassword = form.watch("newPassword");

  const passwordMatch = newPassword && confirmPassword && newPassword === confirmPassword;
  const showPasswordMatchError = confirmPassword && !passwordMatch;

  return (
    <div className="pc:max-w-[420px] w-full">
      <h3 className="heading-3-bold tb:mb-10 mb-8 text-center text-gray-900">{t("f_rp_title")}</h3>
      <div className="tb:space-y-6 space-y-3">
        {/* 이메일 표시 (수정 불가) */}
        <div>
          <FormLabel className="body-md-bold tb:mb-2 mb-[6px] text-gray-900">{t("f_rp_lable_id")}</FormLabel>
          <div className="body-md-regular tb:rounded-10 tb:py-[13px] w-full rounded-[8px] border border-gray-200 bg-gray-50 px-4 py-[11px] text-gray-400">
            {form.watch("email")}
          </div>
        </div>

        {/* 비밀번호 입력 */}
        <FormField
          control={form.control}
          name="newPassword"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="newPassword" className="body-md-bold text-gray-900">
                {t("f_rp_lable_pw")}
              </FormLabel>
              <FormControl>
                <Input
                  id="newPassword"
                  variant="public"
                  type="password"
                  placeholder={t("f_rp_placeholder_pw")}
                  value={field.value || ""}
                  onChange={field.onChange}
                  maxLength={50}
                />
              </FormControl>
            </FormItem>
          )}
        />

        {/* 비밀번호 확인 */}

        <FormItem>
          <FormLabel htmlFor="confirmPassword" className="body-md-bold text-gray-900">
            {t("f_rp_lable_pc")}
          </FormLabel>
          <FormControl>
            <Input
              id="confirmPassword"
              variant="public"
              type="password"
              placeholder={t("f_rp_placeholder_pc")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              maxLength={50}
            />
          </FormControl>
          {form.formState.errors.newPassword && (
            <span className="body-sm-regular text-red-500">{form.formState.errors.newPassword.message}</span>
          )}
          {showPasswordMatchError && <span className="body-sm-regular text-red-500">{t("f_rp_err_2")}</span>}
        </FormItem>
      </div>

      <Button type="submit" className="mt-10 w-full" variant="primary" size="lg" disabled={form.formState.isSubmitting}>
        {t("f_rp_btn")}
      </Button>
    </div>
  );
}
